import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["value", "onChange", "label", "fullWidth", "children", "required", "classes", "showItemIcon"];

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import React, { useEffect, useMemo, useState } from 'react';
import { Search, InputAdornment } from '@ellucian/react-design-system/core';
import { withEDSContext } from '../EDSContext/EDSContext';
import { default as withStyles } from '../styles';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import get from 'lodash/get';
import { spacing30 } from '../styles/tokens';

var styles = function styles(theme) {
  return {
    positionStart: {
      marginRight: "" + spacing30
    }
  };
};
/**
 * Get the display text of the dropdown.
 */


function getDisplayText(value, valueMap) {
  var label;

  if (!isNil(value) && !isEmpty(valueMap)) {
    if (isNil(valueMap[value])) {
      console.error("Unknown value: " + value);
    } else {
      label = valueMap[value].props.label;
    }
  }

  return label;
}
/**
 * Get the icon for the dropdown typeahead item
 */


function getValueIcon(value, valueMap, classes) {
  if (value === void 0) {
    value = {};
  }

  if (valueMap === void 0) {
    valueMap = {};
  }

  var leftIconComponent = get(valueMap[value], 'props.LeftIconComponent');

  if (leftIconComponent) {
    return /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start",
      classes: {
        root: classes.positionStart
      }
    }, leftIconComponent);
  } else {
    return undefined;
  }
}
/**
 * A dropdown that support typeahead item search.
 *
 * @done true
 * @updated v6.5.0
 * @versionAdded v5.5.0
 * @examples
 *  DropdownTypeaheadExample
 *  DropdownTypeaheadRequiredExample
 *  DropdownTypeaheadIconExample
 */


var DropdownTypeahead = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var value = props.value,
      onChangeProp = props.onChange,
      label = props.label,
      fullWidth = props.fullWidth,
      children = props.children,
      required = props.required,
      classes = props.classes,
      showItemIcon = props.showItemIcon,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var _useState = useState(),
      dropdownItems = _useState[0],
      setDropdownItems = _useState[1];

  var _useState2 = useState({}),
      valueMap = _useState2[0],
      setValueMap = _useState2[1];

  var _useState3 = useState(),
      localValue = _useState3[0],
      setLocalValue = _useState3[1];

  var _useState4 = useState(),
      dropdownIcon = _useState4[0],
      setDropdownIcon = _useState4[1];

  var allChildren = useMemo(function () {
    return React.Children.toArray(children);
  }, [children]);
  useEffect(function () {
    setDropdownItems(allChildren);
    var map = allChildren.reduce(function (accumulator, val) {
      accumulator[val.props.value] = val;
      return accumulator;
    }, {});
    setValueMap(map);
  }, [allChildren]);
  useEffect(function () {
    setLocalValue(getDisplayText(value, valueMap));
    setDropdownIcon(getValueIcon(value, valueMap, classes));
  }, [value, valueMap, classes]);

  function filter(searchValue, item) {
    return !item.props.disabled && item.props.label.toLowerCase().startsWith(searchValue.toLowerCase());
  } // TODO: We may need to optionally provide devs to implement this filter function


  var onFilter = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(searchValue, categoryIndex, event) {
      var filterText, items;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              filterText = searchValue.trim();

              if (isEmpty(filterText)) {
                items = allChildren;
              } else {
                items = React.Children.toArray(children).filter(function (item) {
                  return filter(filterText, item);
                });
              }

              setDropdownItems(items);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onFilter(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();

  var onClear = function onClear(event) {
    onChangeProp(undefined, event);
    setLocalValue(undefined);
    setDropdownItems(allChildren);
  };

  var onItemSelect = function onItemSelect(event, index, option) {
    onChangeProp(dropdownItems[index].props.value, event);
  };

  var onChange = function onChange(event) {
    setLocalValue(event.target.value);
    setDropdownIcon(getValueIcon(event.target.value, valueMap, classes));
  };

  return /*#__PURE__*/React.createElement(Search, _extends({
    onChange: onChange,
    ref: ref,
    onClear: onClear,
    value: localValue,
    label: required ? label + " *" : label,
    fullWidth: fullWidth,
    isDropdown: true,
    placeholder: "",
    typeaheadOptions: {
      loading: false,
      onFilter: onFilter,
      onItemSelect: onItemSelect,
      searchDelay: 0
    },
    dropdownItemIcon: showItemIcon ? dropdownIcon : undefined
  }, rest), dropdownItems);
});
DropdownTypeahead.muiName = 'DropdownTypeahead';
DropdownTypeahead.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,

  /**
   * The dropdown value. This corresponds to the `value` of the selected
   * `DropdownTypeaheadItem`.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),

  /**
   * Label that is attached to the `DropdownTypeahead`
   */
  label: PropTypes.string.isRequired,

  /**
   * Callback function fired when a dropdown item is selected.
   *
   * Signature:
   * ```
   * function(value: <any>, event: object) => void
   * ```
   * * `value`: The value that uniquely identifies the selected item. `undefined` if nothing is selected.
   * * `event`: The event source of the callback.
   */
  onChange: PropTypes.func,

  /**
   * If `true`, the dropdown will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the dropdown will display in an error state
   */
  error: PropTypes.bool,

  /**
   * If `true`, the dropdown will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * Text to be displayed by the FormHelperText component
   */
  helperText: PropTypes.string,

  /**
   * Id assigned to the input element and referenced by label element
   */
  id: PropTypes.string,

  /**
   * Marks the dropdown required
   */
  required: PropTypes.bool,

  /**
   * Size of the drodpdown. Valid values are 'medium' (the default) and 'small'.
   */
  size: PropTypes.string,

  /**
   * If `true`, the dropdown will show the `LeftIconComponent` that corresponds with the `DropdownTypeaheadItem` in the input field when selected.
   */
  showItemIcon: PropTypes.bool
};
DropdownTypeahead.defaultProps = {
  required: false,
  disabled: false,
  fullWidth: false,
  error: false,
  showItemIcon: false,
  size: 'medium'
};
export default withEDSContext(withStyles(styles)(DropdownTypeahead));